import React, { useEffect } from 'react';
import { useLayoutEffect } from "react";
import {
  BrowserRouter,
  HashRouter as HashRouterRouter,
  Route,
  Routes,
} from "react-router-dom";
import { ProtectedRoute } from "./layout/ProtectedRoute";
import { continueSession } from "./services/Validation";

import "./App.css";

import Inicio from "./componentes/Inicio/FondoInicial";
import NavBar from "./layout/NavBar";

import { Toast } from './layout/Alerta';
import { updateSimple } from './services/CatalogoServices';
import { userRolEnum } from './types/enumTypes';
import ListaUsuarios from './componentes/Admin/Usuarios/ListaUsuarios';
import montosPF from './componentes/Admin/ParticipacionesFederales/MontosPF';
import MontosPF from './componentes/Admin/ParticipacionesFederales/MontosPF';
import MontosPE from './componentes/Admin/ParticipacionesEstatales/MontosPE';
import MontosAF from './componentes/Admin/AportacionesFederales/MontosAF';
import MontosAE from './componentes/Admin/AportacionesEstatales/MontosAE';
import SolicitudReportePF from './componentes/Admin/ParticipacionesFederales/SolicitudReportePF';
import VerifiacionMontosPF from './componentes/Admin/ParticipacionesFederales/VerificacionMontosPF';
import AcuerdosPF from './componentes/Admin/ParticipacionesFederales/AcuerdosPF';
import SolicitudAcuerdosPF from './componentes/Admin/ParticipacionesFederales/SolicitudAcuerdosPF';
import SolicitudReportePE from './componentes/Admin/ParticipacionesEstatales/SolicitudReportePE';

import SolicitudReporteAE from './componentes/Admin/AportacionesEstatales/SolicitudReporteAE';
import VerifiacionMontosAE from './componentes/Admin/AportacionesEstatales/VerificacionMontosAE';
import VerificacionMontosPE from './componentes/Admin/ParticipacionesEstatales/VerificacionMontosPE';
import VerificacionMontosPF from './componentes/Admin/ParticipacionesFederales/VerificacionMontosPF';
import VerificacionAcuerdosPF from './componentes/Admin/ParticipacionesFederales/VerificacionAcuerdosPF';
import VerificacionMontosAE from './componentes/Admin/AportacionesEstatales/VerificacionMontosAE';
import SolicitudReporteAF from './componentes/Admin/AportacionesFederales/SolicitudReporteAF';
import VerificacionMontosAF from './componentes/Admin/AportacionesFederales/VerificacionMontosAF';
import AcuerdosAF from './componentes/Admin/AportacionesFederales/AcuerdosAF';
import SolicitudAcuerdosAF from './componentes/Admin/AportacionesFederales/SolicitudAcuerdoAF';
import Catalogos from './componentes/Admin/Catalogos/Catalogos';
import TipoProceso from './componentes/Admin/Catalogos/TipoProceso';
import Enlaces from './componentes/Admin/Catalogos/Enlaces';
import Fondos from './componentes/Admin/Catalogos/Fondos';
import { PublicRoute } from './layout/PublicRoute';
import HomePage from './componentes/Publico/HomePage';
import HomePagePF from './componentes/Publico/HomePagePF';
import Municipios from './componentes/Admin/Catalogos/Municipios';
import TipoPublicacion from './componentes/Admin/Catalogos/TipoPublicacion';
import CalculosPF from './componentes/Admin/ParticipacionesFederales/CalculosPF';
import SolicitudCalculosPF from './componentes/Admin/ParticipacionesFederales/SolicitudCalculosPF';
import VerificacionMemoriasPF from './componentes/Admin/ParticipacionesFederales/VerificacionMemoriasPF';
import AltaUsuarios from './componentes/Admin/Usuarios/AltaUsuarios';
import EditaUsuarios from './componentes/Admin/Usuarios/EditaUsuarios';
import HomePagePE from './componentes/Publico/HomePagePE';
import CalculosPE from './componentes/Admin/ParticipacionesEstatales/CalculosPE';
import SolicitudCalculosPE from './componentes/Admin/ParticipacionesEstatales/SolicitudCalculosPE';
import VerificacionMemoriasPE from './componentes/Admin/ParticipacionesEstatales/VerificacionMemoriasPE';
import HomePageAF from './componentes/Publico/HomePageAF';
import VerifiacionAcuerdosAF from './componentes/Admin/AportacionesFederales/VerificacionAcuerdosAF';
import VerifiacionAcuerdosPF from './componentes/Admin/ParticipacionesFederales/VerificacionAcuerdosPF';
import VerificacionAcuerdosAF from './componentes/Admin/AportacionesFederales/VerificacionAcuerdosAF';
import AdministracionAyuda from './componentes/Ayuda/AdministracionAyuda';
import CalculosAF from './componentes/Admin/AportacionesFederales/CalculosAF';
import SolicitudCalculosAF from './componentes/Admin/AportacionesFederales/SolicitudCalculoAFs';
import VerificacionMemoriasAF from './componentes/Admin/AportacionesFederales/VerificacionMemoriasAF';
import CalculosAE from './componentes/Admin/AportacionesEstatales/CalculosAE';
import SolicitudCalculosAE from './componentes/Admin/AportacionesEstatales/SolicitudCalculosAE';
import VerificacionMemoriasAE from './componentes/Admin/AportacionesEstatales/VerificacionMemoriasAE';
import HomePageAE from './componentes/Publico/HomePageAE';
import LoginPrueba from './componentes/Admin/ParticipacionesFederales/LoginPrueba';
import DashboardPrueba from './componentes/Admin/ParticipacionesFederales/DashboardPrueba';

function App() {
  const BASENAME = process.env.REACT_APP_BASENAME || "/";
  return (
    <BrowserRouter basename={BASENAME}>
      <Routes>
        <Route index
          path="/"
          element={
            <PublicRoute children={<HomePage />} />
          }
        />
        <Route index
          path="/participaciones-federales/:tipo"
          element={
            <PublicRoute children={<HomePagePF />} />
          }
        />
        <Route index
          path="/participaciones-estatales/:tipo"
          element={
            <PublicRoute children={<HomePagePE />} />
          }
        />
        <Route index
          path="/aportaciones-federales/:tipo"
          element={
            <PublicRoute children={<HomePageAF />} />
          }
        />
        <Route index
          path="/aportaciones-estatales/:tipo"
          element={
            <PublicRoute children={<HomePageAE />} />
          }
        />
        <Route
          index
          path="/admin"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<Inicio />}
            />
          }
        />

        <Route
          index
          path="/admin/participaciones/federales/montos"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<MontosPF />}
            />
          }
        />
        <Route
          index
          path="/admin/participaciones/federales/acuerdos"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<AcuerdosPF />}
            />
          }
        />
        <Route
          index
          path="/admin/participaciones/federales/solicitudreportepf"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<SolicitudReportePF />}
            />
          }
        />
        <Route
          index
          path="/admin/participaciones/federales/solicitudacuerdospf"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<SolicitudAcuerdosPF />}
            />
          }
        />
        <Route
          index
          path="/admin/participaciones/federales/verificacionmontospf/:id"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<VerificacionMontosPF />}
            />
          }
        />
        <Route
          index
          path="/admin/participaciones/federales/verificacionacuerdospf/:id"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<VerificacionAcuerdosPF />}
            />
          }
        />
        <Route
          index
          path="/admin/participaciones/federales/memoriasdecalculo"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<CalculosPF />}
            />
          }
        />
        <Route
          index
          path="/admin/participaciones/federales/solicitudcalculospf"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<SolicitudCalculosPF />}
            />
          }
        />
        <Route
          index
          path="/admin/participaciones/federales/verificacionmemoriasaf/:id"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<VerificacionMemoriasPF />}
            />
          }
        />

        {/* ------------- participaciones-estatales-----------------------------*/}
        <Route
          index
          path="/admin/participaciones/estatales/montos"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<MontosPE />}
            />
          }
        />

        <Route
          index
          path="/admin/participaciones/estatales/solicitudreportepe"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<SolicitudReportePE />}
            />
          }
        />
        <Route
          index
          path="/admin/participaciones/estatales/verificacionmontospe/:id"

          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<VerificacionMontosPE />}
            />
          }
        />
        <Route
          index
          path="/admin/participaciones/estatales/memoriasdecalculo"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<CalculosPE />}
            />
          }
        />

        <Route
          index
          path="/admin/participaciones/estatales/verificacionmemoriaspe/:id"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<VerificacionMemoriasPE />}
            />
          }
        />


        <Route
          index
          path="/admin/participaciones/estatales/solicitudcalculospe"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<SolicitudCalculosPE />}
            />
          }
        />

        {/* ------------- aportaciones-federales-----------------------------*/}
        <Route
          index
          path="/admin/aportaciones/federales/montos"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<MontosAF />}
            />
          }
        />

        <Route
          index
          path="/admin/aportaciones/federales/acuerdos"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<AcuerdosAF />}
            />
          }
        />
        <Route
          index
          path="/admin/aportaciones/federales/solicitudreporteaf"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<SolicitudReporteAF />}
            />
          }
        />
        <Route
          index
          path="/admin/aportaciones/federales/verificacionmontosaf/:id"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<VerificacionMontosAF />}
            />
          }
        />
        <Route
          index
          path="/admin/aportaciones/federales/solicitudacuerdosaf"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<SolicitudAcuerdosAF />}
            />
          }
        />
        <Route
          index
          path="/admin/aportaciones/federales/verificacionacuerdosaf/:id"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<VerificacionAcuerdosAF />}
            />
          }
        />

        <Route
          index
          path="/admin/aportaciones/federales/memoriasdecalculo"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={< CalculosAF />}
            />
          }
        />
        <Route
          index
          path="/admin/aportaciones/federales/solicitudcalculosaf"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<SolicitudCalculosAF />}
            />
          }
        />

        <Route
          index
          path="/admin/aportaciones/federales/verificacionmemoriasaf/:id"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<VerificacionMemoriasAF />}
            />
          }
        />


        {/* ------------- aportaciones-estatales-----------------------------*/}
        <Route
          index
          path="/admin/aportaciones/estatales/montos"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<MontosAE />}
            />
          }
        />

        <Route
          index
          path="/admin/aportaciones/estatales/solicitudreporteae"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<SolicitudReporteAE />}
            />
          }
        />

        <Route
          index
          path="/admin/aportaciones/estatales/verificacionmontosae/:id"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<VerificacionMontosAE />}
            />
          }
        />

        <Route
          index
          path="/admin/aportaciones/estatales/memoriasdecalculo"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<CalculosAE />}
            />
          }
        />
        <Route
          index
          path="/admin/aportaciones/estatales/solicitudcalculosaf"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<SolicitudCalculosAE />}
            />
          }
        />

        <Route
          index
          path="/admin/aportaciones/estatales/verificacionmemoriasaf/:id"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<VerificacionMemoriasAE />}
            />
          }
        />

        {/* ----------------------Catalogos-----------------------------*/}

        <Route
          index
          path="/admin/catalogos"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<Catalogos />}
            />
          }
        />

        <Route
          index
          path="/admin/catalogos/proceso"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<TipoProceso />}
            />
          }
        />
        <Route
          index
          path="/admin/catalogos/fondos"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<Fondos />}
            />
          }
        />
        <Route
          index
          path="/admin/catalogos/enlaces"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<Enlaces />}
            />
          }
        />

        <Route
          index
          path="/admin/catalogos/municipios"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<Municipios />}
            />
          }
        />

        <Route
          index
          path="/admin/catalogos/tipopublicacion"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<TipoPublicacion />}
            />
          }
        />

        <Route
          index
          path="/admin/catalogos/login"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<LoginPrueba />}
            />
          }
        />
        <Route
          index
          path="/admin/catalogos/dashboard"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<DashboardPrueba />}
            />
          }
        />
        {/* ----------------------Usuarios-----------------------------*/}
        <Route
          index
          path="/admin/configuracion/usuarios"
          element={
            <ProtectedRoute
              roles={[]}
              children={<ListaUsuarios />}
            />
          }
        />
        <Route
          index
          path="/admin/configuracion/usuarios/alta"
          element={
            <ProtectedRoute
              roles={[]}
              children={<AltaUsuarios />}
            />
          }
        />
        <Route
          index
          path="/admin/configuracion/usuarios/edita/:id"
          element={
            <ProtectedRoute
              roles={[]}
              children={<EditaUsuarios />}
            />
          }
        />

        {/* ----------------------Convenios-----------------------------*/}

        <Route
          index
          path="/admin/convenios"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida, userRolEnum.carga, userRolEnum.revisa]}
              children={<p>Convenios</p>}
            />
          }
        />

        {/* ----------------------Cambiar Contraseña-----------------------------*/}

        <Route
          index
          path="/admin/cambiarcontraseña"
          element={
            <ProtectedRoute
              roles={[userRolEnum.valida]}
              children={<p>Cambiar Contraseña</p>}
            />
          }
        />

        <Route
          path="/AdministracionAyudas"
          element={
            <ProtectedRoute
              roles={[
                userRolEnum.admin,
              ]}
              children={<AdministracionAyuda />}
            />
          }
        />

        <Route path="*" element={<p>404 - No encontrado</p>} />
      </Routes>
    </BrowserRouter>

  );
}

export default App;
